import {useEffect,useState} from 'react';
import {useNavigate,useParams} from 'react-router-dom';
import api from '@/lib/api';

// Authenticated landing for Audit OS links in Word exports (M8-13). The link holds no token;
// the server decides whether this user may open the record and where it lives.
export default function DeepLinkOpen(){
 const {kind,id}=useParams();const navigate=useNavigate();const [failed,setFailed]=useState(false);
 useEffect(()=>{
  let live=true;
  api.get(`/deep-links/${encodeURIComponent(kind)}/${encodeURIComponent(id)}`)
   .then(({data})=>{if(live&&typeof data?.path==='string'&&data.path.startsWith('/engagements/'))navigate(data.path,{replace:true});else if(live)setFailed(true);})
   .catch(()=>{if(live)setFailed(true);});
  return()=>{live=false;};
 },[kind,id,navigate]);
 return <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground" data-testid="deep-link-open">
  {failed?<p role="alert">Tautan tidak tersedia, atau Anda tidak memiliki akses ke catatan ini.</p>:<p>Membuka catatan…</p>}
 </div>;
}
